<template>
  <div class="page-wrapper chiller-theme toggled" id="main">
    <main-sidebar :has-permission="hasPermission"></main-sidebar>
    <main class="page-content">
      <main-header></main-header>
      <user-data v-if="selectedTab === 'users'" :has-permission="hasPermission"></user-data>
      <role-data v-else-if="selectedTab === 'roles'" :has-permission="hasPermission"></role-data>
      <log
        v-else-if="selectedTab === 'logs'"
        :has-permission="hasPermission"
      ></log>
    </main>
  </div>
</template>

<script>
  import MainHeader from './../layout/MainHeader.vue'
  import MainSidebar from './../layout/MainSidebar.vue'
  import UserData from './UserData.vue'
  import RoleData from './RoleData.vue'
  import Log from './Log.vue'

  export default {
    name: 'users',
    components: {
      MainHeader,
      MainSidebar,
      UserData,
      RoleData,
      Log
    },
    data() {
      return {
        permissions: this.$auth.getPermissions()
      }
    },
    mounted() {
      this.$nextTick(() => {
        // Sidebar open
        $("#show-sidebar").click(function () {
          $(".page-wrapper").addClass("toggled");
        });

        // Sidebar close
        $("#close-sidebar").click(function () {
          $(".page-wrapper").removeClass("toggled");
        });

        // Responsive auto toggle
        const windowWidth =
          window.screen.width < window.outerWidth
            ? window.screen.width
            : window.outerWidth;

        if (windowWidth < 768) {
          $(".page-wrapper").removeClass("toggled");
        }

        if (windowWidth > 768) {
          $(".page-wrapper").addClass("toggled");
        }
      });
    },
    methods: {},
    computed: {
      currentComponent() {
        return this.selectedTab === 'users' ? 'UserData' : 'RoleData';
      },
      selectedTab() {
        return this.$store.getters.selectedTab;
      },
      hasPermission() {
        return (name) => {
          if (this.permissions.length === 0) return false
          return this.permissions.includes(name)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/users/users/Index.vue